import React from "react";
import { Testimonial } from "@scrile/api-provider/dist/api/TestimonialsProvider";
import { MediaFilesController } from "lib/MediaFileController";
import "./style.scss";

interface Props {
  item: Testimonial;
}

export default function TestimonialItem({ item }: Props) {
  const src =
    (item.avatar && MediaFilesController.getImageThumbnail(item.avatar.urlPart, "480p")) ||
    "/images/default-avatar.svg";
  return (
    <div className="wwh-testimonial-item box-shadow gap-6">
      <div className="wwh-testimonial-item__text-wrapper d-flex __column">
        <div className="wwh-testimonial-item__text caption-1 fw-bold">&quot;{item.text}&quot;</div>
        <div className="body-big">{item.name}</div>
        <div className="mt-1 body-1 fw-semibold">{item.role}</div>
        <div className="wwh-testimonial-item__background mt-1 body-3">{item.background}</div>
      </div>
      <div className="wwh-testimonial-item__avatar" style={{ backgroundImage: `url(${src})` }}></div>
    </div>
  );
}
